import { Link } from 'react-router-dom';
import { useContent } from '@/hooks/useContent';

const Footer = () => {
  const { t } = useContent();

  return (
    <footer className="bg-light-secondary dark:bg-dark-secondary border-t border-light-text/10 dark:border-dark-text/10 mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src="/assets/images/elhamylab1024.jpeg"
                alt="ElhamyLabs"
                className="h-12 w-auto object-contain"
              />
              <span className="text-xl font-bold text-brand-purple-dark dark:text-brand-orange-base">
                {t('common.brandName')}
              </span>
            </Link>
            <p className="text-light-text-secondary dark:text-dark-text-secondary text-sm">
              {t('home.hero.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4 text-light-text dark:text-dark-text">
              {t('common.services')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/services"
                  className="text-light-text-secondary dark:text-dark-text-secondary hover:text-brand-purple-base dark:hover:text-brand-orange-base transition-colors text-sm"
                >
                  {t('common.services')}
                </Link>
              </li>
              <li>
                <Link
                  to="/tests"
                  className="text-light-text-secondary dark:text-dark-text-secondary hover:text-brand-purple-base dark:hover:text-brand-orange-base transition-colors text-sm"
                >
                  {t('common.tests')}
                </Link>
              </li>
              <li>
                <Link
                  to="/branches"
                  className="text-light-text-secondary dark:text-dark-text-secondary hover:text-brand-purple-base dark:hover:text-brand-orange-base transition-colors text-sm"
                >
                  {t('common.branches')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4 text-light-text dark:text-dark-text">
              {t('common.contact')}
            </h3>
            <ul className="space-y-2 text-light-text-secondary dark:text-dark-text-secondary text-sm">
              <li className="mb-2">
                <span className="font-medium">{t('footer.phone')}:</span>
                <div className="mt-1 space-y-1" dir="ltr">
                  <a href="tel:+201006076325" className="block hover:text-brand-purple-base dark:hover:text-brand-orange-base transition-colors">
                    {t('footer.phone1')}
                  </a>
                  <a href="tel:+20402212255" className="block hover:text-brand-purple-base dark:hover:text-brand-orange-base transition-colors">
                    {t('footer.phone2')}
                  </a>
                  <a href="tel:+20402213030" className="block hover:text-brand-purple-base dark:hover:text-brand-orange-base transition-colors">
                    {t('footer.phone3')}
                  </a>
                </div>
              </li>
              <li className="mt-3">
                <span className="font-medium">{t('footer.email')}:</span>{' '}
                <a href="mailto:info@elhamylabs.com" className="hover:text-brand-purple-base dark:hover:text-brand-orange-base transition-colors">
                  info@elhamylabs.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-light-text/10 dark:border-dark-text/10 mt-8 pt-8 text-center text-light-text-secondary dark:text-dark-text-secondary text-sm">
          <p>&copy; {new Date().getFullYear()} {t('common.brandName')}. {t('footer.copyright')}.</p>
          <p className="mt-2 text-xs opacity-90">
            {t('footer.builtBy')}{' '}
            <a
              href="https://ekosysco.elhamylabs.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="eko-credit"
            >
              EKOsysco
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

